/* eslint-disable max-classes-per-file */
/* eslint-disable no-undef */
import { Cookies } from 'react-cookie';

import { META_DATA_KEY } from '../utils/constants';

class ApiError extends Error {

  constructor(result, httpStatus) {
    super(result?.message || 'API Error');
    // Spread all result properties first for backward compatibility
    Object.assign(this, result);

    this.name = 'ApiError';
    // HTTP status code available via httpStatus
    this.httpStatus = httpStatus;
    // Ensure code is set for backward compatibility
    if (this.code === undefined) {
      this.code = httpStatus;
    }
  }

}

const METADATA_HEADER = 'x-metadata';

const cookies = new Cookies();

const CSRF_HEADER = {
  _csrf: {
    toString() {
      return cookies.get('_csrf');
    },
  },
  'x-xsrf-token': {
    toString() {
      return cookies.get('XSRF-TOKEN');
    },
  },
};

const DEFAULT_HEADERS = {
  'X-Version': WEB_PLUGIN_VERSION,
  [METADATA_HEADER]: sessionStorage.getItem(META_DATA_KEY),
  'Content-Type': 'application/json',
  ...CSRF_HEADER,
};

class AjaxUtils {

  async patch(route, data, isFullUrl = false) {
    const options = {
      method: 'PATCH',
      credentials: 'include',
      mode: 'cors',
      headers: {
        ...DEFAULT_HEADERS,
      },
      body: JSON.stringify(data),
    };

    const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
    const request = new Request(url.toString(), options);

    return this._fetch(request);
  }

  async post(route, data, isFullUrl = false, withCookies = true) {
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        ...DEFAULT_HEADERS,
        Accept: 'application/json',
        'x-px-cookies': localStorage.getItem('pxcookie') || '',
      },
      body: JSON.stringify(data),
    };

    if (withCookies) {
      options.credentials = 'include';
    }

    const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
    const request = new Request(url.toString(), options);

    return this._fetch(request);
  }

  async delete(route, isFullUrl = false) {
    const options = {
      method: 'DELETE',
      credentials: 'include',
      mode: 'cors',
      headers: {
        ...DEFAULT_HEADERS,
      },
    };

    const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
    const request = new Request(url.toString(), options);

    return this._fetch(request);
  }

  async search(route, data) {
    const options = {
      method: 'POST',
      credentials: 'include',
      mode: 'cors',
      headers: {
        ...DEFAULT_HEADERS,
        Accept: 'application/json',
        'x-px-cookies': localStorage.getItem('pxcookie') || '',
      },
      body: JSON.stringify(data),
    };

    const url = new URL(envConfig.OUTBOUND_SEARCH_URL + route);
    const request = new Request(url.toString(), options);

    return this._fetch(request);
  }

  async get(route, isFullUrl = false) {
    const options = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      headers: {
        ...DEFAULT_HEADERS,
      },
    };

    const url = isFullUrl ? new URL(route) : new URL(envConfig.OUTBOUND_SERVER_URL + route);
    const request = new Request(url.toString(), options);

    return this._fetch(request);
  }

  async _fetch(request) {
    const fetchResult = await fetch(request);
    let result;

    try {
      const responseText = await fetchResult?.text();

      // If response is empty or just whitespace, return empty object for successful requests
      if (fetchResult.ok && (!responseText || responseText.trim() === '')) {
        return {};
      }
      // Try to parse as JSON
      result = JSON.parse(responseText);
    } catch (e) {
      if (fetchResult && !fetchResult.ok) {
        throw fetchResult;
      }

      throw e;
    }

    if (fetchResult.ok) {
      return result;
    }
    throw new ApiError(result, fetchResult.status);
  }

}

export default new AjaxUtils();

